import colors from "assets/colors";
import { CSSProperties } from "react";

const NoDataContainerStyle: CSSProperties = {
  padding: "1em",
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
};

const NoDataSpanStyle: CSSProperties = {
  backgroundColor: colors.hexToRgba(colors.warn, 0.3),
  padding: "1em 4em",
  borderRadius: "1em",
  border: `1px solid ${colors.warn}`,
};

const NoDataComponent = ({ isLoading }: { isLoading: boolean }) => {
  if (isLoading) return null;
  return (
    <div style={NoDataContainerStyle}>
      <span style={NoDataSpanStyle}>學生暫時沒有完成該範疇練習</span>
    </div>
  );
};

export default NoDataComponent;
